import { useSettings } from "@/context/SettingsContext";
import { trackClick } from "@/lib/api";
import { Instagram, Send, Bot, MessageCircle, Crown, Music2 } from "lucide-react";

export default function Community() {
  const s = useSettings();

  const cards = [
    {
      icon: Instagram, title: "Instagram",
      text: "Segui Vinko su Instagram per promo, novità, contenuti e aggiornamenti.",
      cta: "SEGUI VINKO SU INSTAGRAM", link: s.instagram_url, kind: "instagram",
      show: true, testid: "community-card-instagram",
    },
    {
      icon: Bot, title: "Telegram Bot",
      text: "Utilizza l'assistente virtuale Vinko direttamente su Telegram.",
      cta: "AVVIA IL BOT", link: s.telegram_bot_url, kind: "telegram_bot",
      show: true, testid: "community-card-bot",
    },
    {
      icon: Send, title: "Telegram gratuito",
      text: "Entra gratuitamente nel canale Telegram per ricevere aggiornamenti, comunicazioni e contenuti Vinko.",
      cta: "ENTRA GRATIS", link: s.telegram_free_url, kind: "telegram_free",
      show: true, testid: "community-card-free",
    },
    {
      icon: MessageCircle, title: "WhatsApp",
      text: "Contatta direttamente l'assistenza Vinko tramite WhatsApp.",
      cta: "CONTATTACI SU WHATSAPP", link: s.whatsapp_url, kind: "whatsapp",
      show: true, testid: "community-card-whatsapp",
    },
    {
      icon: Music2, title: "TikTok",
      text: "Segui Vinko su TikTok per nuovi contenuti e aggiornamenti.",
      cta: "SEGUI SU TIKTOK", link: s.tiktok_url, kind: "tiktok",
      show: !!s.tiktok_active && !!s.tiktok_url, testid: "community-card-tiktok",
    },
    {
      icon: Crown, title: "Telegram VIP",
      text: "Scopri i contenuti e i servizi riservati alla community Vinko VIP.",
      cta: "ACCEDI AL VIP", link: s.telegram_vip_url, kind: "telegram_vip",
      show: !!s.telegram_vip_active && !!s.telegram_vip_url, testid: "community-card-vip",
    },
  ];

  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 py-14 sm:py-20">
      <span className="text-xs font-bold uppercase tracking-[0.25em] text-yellow-500">Canali ufficiali</span>
      <h1 className="mt-3 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tighter">
        Entra nella <span className="text-yellow-400">community Vinko</span>
      </h1>

      <div className="mt-10 grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {cards.filter((c) => c.show).map(({ icon: Ic, title, text, cta, link, kind, testid }) => (
          <div key={title} data-testid={testid} className="rounded-2xl border border-white/10 bg-[#101010] p-6 flex flex-col hover:border-yellow-400/40 transition-colors duration-200">
            <div className="h-11 w-11 rounded-xl bg-yellow-400/10 border border-yellow-400/25 grid place-items-center text-yellow-400 mb-4">
              <Ic className="w-5 h-5" />
            </div>
            <h3 className="text-lg font-semibold">{title}</h3>
            <p className="mt-2 text-sm text-zinc-400 leading-relaxed flex-1">{text}</p>
            <a
              href={link}
              target="_blank" rel="noopener"
              onClick={() => trackClick(kind)}
              className="mt-5 inline-flex items-center justify-center rounded-full bg-yellow-400 hover:bg-yellow-300 text-black font-bold text-sm px-4 py-3 transition-transform duration-200 hover:scale-[1.02]"
            >
              {cta}
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}
